import { Link } from 'react-router-dom';
import { StyledButtonGolden } from './subscribe-button.styles';
import type { SubscribeButtonProps } from './subscribe-button.types';
export const SubscribeButton = ({
  to,
  onClick,
  children,
  'aria-label': ariaLabel,
  ...props
}: SubscribeButtonProps) => <StyledButtonGolden onClick={onClick} aria-label={ariaLabel} variant="solid" color="primary" {...to ? {
  to,
  as: Link
} : {
  as: 'button',
  type: 'button'
}} {...props} data-sentry-element="StyledButtonGolden" data-sentry-component="SubscribeButton" data-sentry-source-file="subscribe-button.tsx">
    {children}
  </StyledButtonGolden>;